export default "__VITE_ASSET__006d8da0__"